import React, {useState, useEffect} from "react";

import { API_URL, GET_USER_RETURN_CALENDAR_TABLE } from "../../../constants";
import { GET_TOKEN } from "../../../helpers";
import { LoadingSpinner } from "../../dashboard/partials/LoadingSpinner";
import { ReactTable } from "../../Global/ReactTable/ReactTable";
import { Modal } from "../../Global/Modal/Modal";
import { EmptyData } from "../../Global/EmptyData/EmptyData";

import "./ReturnsCalendar.css";

export const ReturnsCalendar = () => {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [modalActive, setModalActive] = useState(false);
  
  const [returnsData, setReturnsData] = useState([]);
  const [instructionsTextbox, setInstructionsTextbox] = useState('');


  useEffect(() => {
    setDataLoaded(false)

    fetch(API_URL + GET_USER_RETURN_CALENDAR_TABLE, {
      method: "get",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        setReturnsData([...response])
      })
      .catch(err => console.log(err))
      .finally(() => setDataLoaded(true))
  }, []);



  const ReturnsCalendarColumns = [
    {
      Header: "Country",
      accessor: "country",
      className: "cell_country",
      Cell: (cell) => {
        return <div className="countryCell">
          <img src={cell.data[cell.row.id].country.img} alt="flag" className="flag-icon-img"/>
          {cell.data[cell.row.id].country.name}
        </div>
      }
    },
    {
      Header: "Return period",
      accessor: "period",
      className: "return_period"
    },
    {
      Header: "Return deadline",
      accessor: "deadline",
      className: "return_period"
    },
    {
      Header: "Payment instructions",
      accessor: "instruction",
      className: "cell_instruction",
      Cell: (cell) => {
        return <div className="instruction_wrapper">
          {cell.data[cell.row.id].instruction?.length > 0
            ? (
              <button 
                className='active'
                onClick={() => {
                  setInstructionsTextbox(cell.data[cell.row.id].instruction !== null ? cell.data[cell.row.id].instruction : '')
                  setModalActive(true)
                }}
              />

             )
            : <>-</>
          }
        </div>
      },
    },
  ];

  const ReturnsList = () => {
    return <ReactTable className="returnsDataListTable" columns={ReturnsCalendarColumns} data={returnsData} />
  }

  return (
    <div className='ReturnsCalendar'>
      <div className="Dashboard__content__top-row">
        <h2> Returns calendar </h2>
      </div>

      {dataLoaded 
        ? returnsData.length > 0 ? ReturnsList() : <EmptyData title='You don’t have any returns in calendar'/>
        : <LoadingSpinner/>
      }

      <Modal
        ModalOpenHandler={(value) => setModalActive(value)}
        ModalOpen={modalActive}
        ModalBgCloseDisabled={true}
        customClassName={'modal__read_instructions'}
        title={'Instructions'}
        closeButton
      >
        <div className="instructions">
          <div dangerouslySetInnerHTML={{__html: instructionsTextbox}}/>
        </div>
        <div className="button-wrapper">
          <button className='default_button close_read_instructions' onClick={() => setModalActive(false)}>Close</button>
        </div>
      </Modal>
    </div>
  );
};
